import {
    SESSION_CONTRIBUTOR,
    SESSION_OWNER,
    SESSION_PARTICIPANT,
    SESSION_PATIENT,
    SESSION_VIEWER,
} from 'constants/LU_PermissionGroups';
import * as Immutable from 'immutable';
import isFinite from 'lodash/isFinite';
import isNil from 'lodash/isNil';
import moment from 'moment-timezone';
import {getOrgsFromInstanceRoles, getOwnerFromInstance, getUserGroupUsersFromInstanceRoles} from './role-utils';

export const getSessionUrl = (session) => {
    if (isNil(session) || session.isEmpty() || isNil(session.get('sessionId'))) {
        return null;
    }

    return `/sessions/${session.get('sessionId')}`;
};

export const sessionOwner = (session) => {
    return getOwnerFromInstance(session, SESSION_OWNER);
};

export const sessionContributors = (session) => {
    return getUserGroupUsersFromInstanceRoles(session, SESSION_CONTRIBUTOR);
};

export const sessionViewers = (session) => {
    const users = getUserGroupUsersFromInstanceRoles(session, SESSION_VIEWER);
    const organizations = getOrgsFromInstanceRoles(session, SESSION_VIEWER);

    return users.concat(organizations);
};

export const sessionParticipants = (session) => {
    return getUserGroupUsersFromInstanceRoles(session, SESSION_PARTICIPANT);
};

// we have only one patient per session now, but it's implemented as a usergroup
export const getSessionPatient = (session) => {
    return getUserGroupUsersFromInstanceRoles(session, SESSION_PATIENT).get(0);
};

export const getSessionPeople = (session) => {
    const sessionPeopleEmpty = Immutable.Map({
        owner: undefined,
        participants: Immutable.List(),
        contributors: Immutable.List(),
        viewers: Immutable.List(),
    });

    return isNil(session) || session.isEmpty()
        ? sessionPeopleEmpty
        : sessionPeopleEmpty
              .set('owner', sessionOwner(session))
              .set('participants', sessionParticipants(session))
              .set('contributors', sessionContributors(session))
              .set('viewers', sessionViewers(session));
};

export const getSessionDurationSeconds = (session) => {
    let durationSeconds = null;
    if (!isNil(session) && !isNil(session.get('startTs')) && !isNil(session.get('endTs'))) {
        const duration = moment(session.get('endTs')).diff(moment(session.get('startTs')));
        if (isFinite(duration)) {
            durationSeconds = duration > 0 ? Math.round(duration / 1000) : 0;
        }
    }
    return durationSeconds;
};
